var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8457 14C6.96273 14.2027 7.13105 14.371 7.33373 14.488C7.53642 14.605 7.76633 14.6666 8.00037 14.6666C8.23441 14.6666 8.46432 14.605 8.66701 14.488C8.86969 14.371 9.03801 14.2027 9.15504 14",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17418 10.218C2.08709 10.3134 2.02962 10.4321 2.00875 10.5597C1.98788 10.6872 2.00453 10.818 2.05665 10.9363C2.10878 11.0545 2.19414 11.155 2.30235 11.2256C2.41056 11.2962 2.53697 11.3339 2.66618 11.334H13.3328C13.462 11.334 13.5885 11.2965 13.6968 11.2261C13.805 11.1556 13.8905 11.0552 13.9428 10.937C13.995 10.8188 14.0118 10.688 13.9911 10.5605C13.9704 10.433 13.9131 10.3142 13.8262 10.2187C12.9395 9.30465 11.9995 8.33332 11.9995 5.33398C11.9995 4.27312 11.5781 3.2557 10.8279 2.50556C10.0778 1.75541 9.06038 1.33398 7.99951 1.33398C6.93865 1.33398 5.92123 1.75541 5.17109 2.50556C4.42094 3.2557 3.99951 4.27312 3.99951 5.33398C3.99951 8.33332 3.05885 9.30465 2.17418 10.218Z",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationactive);
export default __webpack_public_path__ + "static/media/notificationactive.deddb171f84e39627ed5670336fa9f43.svg";
export { ForwardRef as ReactComponent };